import React from 'react';

const AdSpace = () => (
    <div style={{ position: 'relative', width: '100%', paddingTop: '11.11%', background: '#343434' }}>
        <div
            className="d-flex align-items-center justify-content-center text-white"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        >
            <div>Ad Space</div>
        </div>
    </div>
);

export default AdSpace;
